module.exports = __webpack_public_path__ + "img/up.a1824167.svg";